// HoloMesh agents consume shared traits from the canonical core traits barrel.
export { agentMemoryHandler as HOLOMESH_AGENT_MEMORY_TRAIT } from '@holoscript/core/traits';
